export default ['nozzle', 'bed', 'ambient'];
